import React from "react";
import { ResponsivePie } from "@nivo/pie";

import { useGetSalesQuery } from "state/api";

// Breakdown Chart
const BreakdownChart = ({ isDashboard = false }) => {
  const { data, isLoading } = useGetSalesQuery();

  // Loader
  if (!data || isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-lg text-muted-foreground">Loading...</p>
      </div>
    );
  }

  // theme colors
  const colors = [
    "hsl(var(--primary))",
    "hsl(var(--secondary))",
    "hsl(var(--accent))",
    "hsl(var(--muted))",
  ];

  // formatted data
  const formattedData = Object.entries(data.salesByCategory).map(
    ([category, sales], i) => ({
      id: category,
      label: category,
      value: sales,
      color: colors[i % colors.length],
    })
  );

  return (
    <div className={`relative ${isDashboard ? 'h-96' : 'h-full'} w-full`}>
      {/* Pie chart */}
      <ResponsivePie
        data={formattedData}
        theme={{
          axis: {
            domain: {
              line: {
                stroke: "hsl(var(--border))",
              },
            },
            legend: {
              text: {
                fill: "hsl(var(--muted-foreground))",
              },
            },
            ticks: {
              line: {
                stroke: "hsl(var(--border))",
                strokeWidth: 1,
              },
              text: {
                fill: "hsl(var(--muted-foreground))",
              },
            },
          },
          legends: {
            text: {
              fill: "hsl(var(--muted-foreground))",
            },
          },
          tooltip: {
            container: {
              color: "hsl(var(--foreground))",
              backgroundColor: "hsl(var(--background))",
              border: "1px solid hsl(var(--border))",
              borderRadius: "6px",
              padding: "8px 12px",
            },
          },
        }}
        colors={{ datum: "data.color" }}
        margin={
          isDashboard
            ? { top: 40, right: 80, bottom: 100, left: 50 }
            : { top: 40, right: 80, bottom: 80, left: 80 }
        }
        sortByValue={true}
        innerRadius={0.45}
        activeOuterRadiusOffset={8}
        borderWidth={1}
        borderColor={{
          from: "color",
          modifiers: [["darker", 0.2]],
        }}
        enableArcLabels={!isDashboard}
        arcLinkLabelsTextColor="hsl(var(--muted-foreground))"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: "color",
          modifiers: [["darker", 2]],
        }}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: isDashboard ? 20 : 0,
            translateY: isDashboard ? 50 : 56,
            itemsSpacing: 0,
            itemWidth: 85,
            itemHeight: 18,
            itemTextColor: "hsl(var(--muted-foreground))",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "hsl(var(--primary))",
                },
              },
            ],
          },
        ]}
      />

      {/* Pie chart center */}
      <div
        className={`absolute text-center pointer-events-none ${
          isDashboard
            ? "top-1/2 left-1/2 transform -translate-x-3/4 -translate-y-3/4"
            : "top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-full"
        }`}
      >
        <p className="text-lg font-semibold text-muted-foreground">
          {!isDashboard && "Total:"} ${data.yearlySalesTotal}
        </p>
      </div>
    </div>
  );
};

export default BreakdownChart;
